import React, { useState, ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import { Can } from 'components';

import { Item, LabelMenu, SubMenu, IconArrowDown, IconArrowUp } from './styles';
import ItemSubMenu from '../ItemSubMenu';

interface Menu {
  name: string;
  route: string;
  icon?: ReactElement | null;
  children: Menu[];
  perm?: string;
  type: 'access' | 'dashboard';
}

interface Props {
  menu: Menu;
}

const ItemMenu: React.FC<Props> = ({ menu }) => {
  const [subnav, setSubnav] = useState(false);

  const showSubnav = () => setSubnav(!subnav);

  return (
    <>
      <Item key={menu.name}>
        <NavLink
          to={menu.route}
          activeClassName={menu.children.length > 0 ? '' : 'sideBarLinkActive'}
          onClick={menu.children && showSubnav}
        >
          {menu.icon}
          <LabelMenu>{menu.name}</LabelMenu>
          {menu.children.length > 0 && !subnav && <IconArrowDown />}
          {menu.children.length > 0 && subnav && <IconArrowUp />}
        </NavLink>
        {subnav && menu.children.length > 0 && (
          <SubMenu className="submenu">
            {menu.children.map((child: Menu) => {
              return child.type === 'access' ? (
                <Can key={child.name} checkAccess={child.perm || ''}>
                  <ItemSubMenu menu={child} />
                </Can>
              ) : (
                <ItemSubMenu key={child.name} menu={child} />
              );
            })}
          </SubMenu>
        )}
      </Item>
    </>
  );
};

export default ItemMenu;
